export default __webpack_public_path__ + "static/media/BNBx.f5baf791.png";